import { Tabs } from 'antd';
import { ApartmentOutlined, ThunderboltOutlined } from '@ant-design/icons';
import RowActionsSection from './RowActionsSection';
import ModuleActionRulesSection from './ModuleActionRulesSection';
import '../../../styles/FormGroupsSection.css';

export default function ActionsSection() {
  return (
    <Tabs
      defaultActiveKey="actions"
      className="admin-config-tabs"
      destroyOnHidden={false}
      items={[
        {
          key: 'actions',
          label: 'Action library',
          icon: <ThunderboltOutlined />,
          children: <RowActionsSection />,
        },
        {
          key: 'rules',
          label: 'Visibility rules',
          icon: <ApartmentOutlined />,
          children: <ModuleActionRulesSection />,
        },
      ]}
    />
  );
}
